import { C } from '../styles';
import BlogLayout, { P, H2b, UL, LI } from './BlogLayout';
import { posts } from './posts';

const meta = posts.find((p) => p.slug === 'custom-metal-fabrication-cost-canada');

const priceRanges = [
  { part: 'Brackets & small fixtures', range: '$50 – $300' },
  { part: 'Shelving & stainless fixtures', range: '$500 – $3,000' },
  { part: 'Prototypes (single unit)', range: '$200 – $2,000' },
  { part: 'HVAC fittings & ductwork parts', range: '$100 – $800' },
];

export default function CustomMetalFabricationCost() {
  return (
    <BlogLayout title={meta.title} description={meta.description}>
      <P>
        Custom metal fabrication pricing in Canada varies widely — the same bracket can cost $60 from one shop and $250 from another, and both prices can be
        reasonable depending on material, tolerances, and volume. Here is what actually drives the number on your quote, and what to expect to pay.
      </P>

      <H2b>What drives the price of a custom metal part</H2b>
      <UL>
        <LI><strong>Material type and thickness</strong> — stainless steel typically costs more than mild steel or aluminum, and thicker stock costs more to cut and form.</LI>
        <LI><strong>Part complexity and tolerances</strong> — tight tolerances, fine features, and multi-step geometry all add machine time and setup cost.</LI>
        <LI><strong>Quantity</strong> — per-unit price drops as volume increases, since setup and programming costs are spread across more parts.</LI>
        <LI><strong>Process type</strong> — CNC machining is generally more expensive per part than sheet metal fabrication for comparable geometry; welding adds labor time on top of material cost.</LI>
        <LI><strong>Finishing</strong> — powder coating, polishing, or plating adds a separate line item beyond the raw fabrication cost.</LI>
      </UL>

      <H2b>Rough price ranges for common projects</H2b>
      <P>
        These are approximate ranges for a single unit or small run, in Canadian dollars. Actual pricing depends on the specifics above — use these as a sanity check, not a quote.
      </P>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 18 }}>
        {priceRanges.map(({ part, range }) => (
          <div key={part} style={{ background: C.surf2, border: `1px solid ${C.bdr}`, borderRadius: 8, padding: '16px 18px' }}>
            <div style={{ fontSize: 12, color: C.dim, letterSpacing: '0.05em', marginBottom: 6 }}>{part}</div>
            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 22, fontWeight: 700, color: C.txt }}>{range}</div>
          </div>
        ))}
      </div>

      <H2b>Tips for getting better pricing</H2b>
      <UL>
        <LI>Order in batches where possible — even 5–10 units instead of 1 can meaningfully lower the per-unit price.</LI>
        <LI>Simplify tolerances and geometry when the application allows it — over-specifying precision you do not need drives up cost for no benefit.</LI>
        <LI>Provide clear specs up front so shops are not padding quotes to cover ambiguity.</LI>
        <LI>Be flexible on material where performance allows — a cheaper equivalent grade can reduce cost without affecting function.</LI>
        <LI>Get multiple quotes on the same brief so you can compare like-for-like instead of guessing whether a price is fair.</LI>
      </UL>
    </BlogLayout>
  );
}
